import React from "react";
import { Link } from "gatsby"
import styled from "styled-components";

import DownloadIcon from "../assets/svg/download.svg";
import GoIcon from "../assets/svg/chevron-circle-right.svg";

const StyledLink = styled(Link)`
    display: inline-block;

    background-color: white;
    border: 0.25em solid var(--kpum-orange);
    border-radius: 0.5rem;

    padding: 0.5em 1em;

    font-weight: bold;
    color: var(--kpum-orange);
    text-decoration: none;

    box-shadow: 0 3px 5px rgb(0 0 0 / 0.25);

    transition: background-color 0.1s, color 0.1s, box-shadow 0.3s, transform 0.1s;

    /* FIXME */
    &:focus {
        outline: none;
        /* text-decoration: underline; */
        /* background-color: rgb(255 165 0 / 0.1); */
    }

    &:hover {
        background-color: var(--kpum-orange);
        color: white;
        box-shadow: 0 5px 8px rgb(0 0 0 / 0.5);
    }

    &:active {
        transform: translateY(0.1em);
    }

    ${ props => props.spaced == "horizontal" ? `
        &:not(:last-child) {
            margin-right: 1em;
        }
    ` : null }

    svg {
        display: inline-block;
    }
`;

// TODO: Destructure additional Link-specific props?
const LinkButton = ({ children, to, external, className, style, spaced, icon, onClick, as }) => (
    <StyledLink
        {...(external ? { as: "a", href: to, onClick: onClick } : { to: to })}
        className={className}
        style={style}
        spaced={spaced}
        as={as}
    >
        {icon == "download" ? (<DownloadIcon />) : null}
        {children}
    </StyledLink>
);

export default LinkButton;